import { render } from "./PSFaceTicketNameDisp.vue?vue&type=template&id=dd4da3be"
import script from "./PSFaceTicketNameDisp.vue?vue&type=script&lang=js"
export * from "./PSFaceTicketNameDisp.vue?vue&type=script&lang=js"

import "./PSFaceTicketNameDisp.vue?vue&type=style&index=0&id=dd4da3be&lang=scss"
script.render = render

export default script